import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/ar';
import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const EvapoChart = ({ data }) => {
  const [state, setState] = useState(null);
  const { t, i18n } = useTranslation();

  const getChartData = () => {
    let labels = [];
    let dataETC = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i]?.dates) {
        const date = moment(data[i].dates)
          .locale(i18n.language)
          .format("MMM DD YYYY");
        labels.push(date);
        dataETC.push(parseFloat(data[i].ETC).toFixed(2));
      }
    }

    setState({
      labels,
      datasets: [
        {
          label: t("etc_mm_label"),
          fill: false,
          lineTension: 0,
          backgroundColor: "rgba(75,192,192,1)",
          borderColor: "#26a6b7",
          borderWidth: 2,
          data: dataETC,
        },
      ],
    });
  };

  useEffect(() => {
    getChartData();
  }, [data, i18n.language]);
  return (
  <div className="w-100 d-flex justify-content-center">
  {state && (
    <div style={{ width: "100%", backgroundColor: "var(--sf-surface, #ffffff)" }}>
      <Line
        data={state}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: {
              display: true,
              text: `${t("ETC")}`,
              font: {
                size: 14,
              },
            },
            legend: {
              display: true,
              position: "bottom",
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              min: 0,
            },
          },
        }}
        height={300}
      />
    </div>
  )}
</div>

  );
};

export default EvapoChart;
